import {ValueObject} from '@s-ui/domain'

/**
 * Represents a single buyer intention
 */
export default class BuyerIntentionUserValueObject extends ValueObject {
  #id
  #shortLabel
  #longLabel

  constructor({id, shortLabel, longLabel}) {
    super()
    this.#id = id
    this.#shortLabel = shortLabel
    this.#longLabel = longLabel
  }

  /**
   * Create from data
   * @param {Object} data
   * @param {string} data.id
   * @param {string} data.shortLabel
   * @param {string} data.longLabel
   * @returns {BuyerIntentionUserValueObject}
   */
  static create({id, shortLabel, longLabel}) {
    return new BuyerIntentionUserValueObject({
      id,
      shortLabel,
      longLabel
    })
  }

  /**
   * Get the intention ID
   * @returns {string}
   */
  getId() {
    return this.#id
  }

  /**
   * Get the short label
   * @returns {string}
   */
  getShortLabel() {
    return this.#shortLabel
  }

  /**
   * Get the long label
   * @returns {string}
   */
  getLongLabel() {
    return this.#longLabel
  }

  /**
   * Get value for serialization
   * @returns {Object}
   */
  get value() {
    return {
      id: this.#id,
      shortLabel: this.#shortLabel,
      longLabel: this.#longLabel
    }
  }

  /**
   * Convert to primitive values
   * @returns {Object}
   */
  toPrimitive() {
    return {
      id: this.#id,
      shortLabel: this.#shortLabel,
      longLabel: this.#longLabel
    }
  }

  /**
   * Convert to JSON (used with static create)
   * @returns {Object}
   */
  toJSON() {
    return {
      id: this.#id,
      shortLabel: this.#shortLabel,
      longLabel: this.#longLabel
    }
  }
}
